import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Languages from 'domain/Languages';

export const CHINESE_LANGUAGE = 'zh-CN';

const DEFAULT_LANGUAGES = [
  {
    code: CHINESE_LANGUAGE,
    label: '中文',
  },
  {
    code: Languages.defaultLanguageCode,
    label: 'EN',
  },
];

class LanguageSwitcher extends PureComponent {
  _handleLanguageChange(languageCode) {
    if (languageCode === this.props.selectedLanguage) return;
    this.props.onLanguageChange(languageCode);
  }

  render() {
    const selectedLanguage = this.props.selectedLanguage || Languages.defaultLanguageCode;

    return <div className={classnames(styles.LanguageSwitcher, this.props.className)}>
      {this.props.languages.map((language) => {
        const isSelected = language.code === selectedLanguage;
        return <button type="button"
            key={language.code}
            className={classnames(
              styles.LanguageSwitcher_option,
              { [styles._selected]: isSelected }
            )}
            onClick={() => this._handleLanguageChange(language.code)}>
          {language.label}
        </button>;
      })}
    </div>;
  }
}

LanguageSwitcher.propTypes = {
  className: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  selectedLanguage: PropTypes.string,
  onLanguageChange: PropTypes.func.isRequired,
};

LanguageSwitcher.defaultProps = {
  languages: DEFAULT_LANGUAGES,
  selectedLanguage: Languages.defaultLanguageCode,
};

export default LanguageSwitcher;



// WEBPACK FOOTER //
// ./components/LanguageSwitcher/index.jsx